import React, { useState } from "react";
import Garment from "./garment";
import { filter, includes, indexOf, length } from "ramda";
import updateArrangementsPrice from "module/functions/updateArrangementsPrice";
import updateArrangementsPriceWithoutDiscount from "module/functions/updateArrangementsPriceWithoutDiscount";
import updateArrangementsDiscount from "module/functions/updateArrangementsDiscount";
import { translate } from "application/functions";

const GarmentManager = (props) => {
  const {
    form,
    register,
    setSelectValue,
    defaultValue,
    errors,
    display,
    setArrangementsPrice,
    setArrangementsPriceWithoutDiscount,
    setArrangementsDiscount,
    setOnFocus,
    windowSize,
    isMobileBrowser,
    deletedProducts,
    setDeletedProducts,
  } = props;
  const [numberItems, setNumberItems] = useState([0]);

  const addItem = () => {
    const lastNumberItem = numberItems[length(numberItems) - 1];
    setNumberItems([...numberItems, lastNumberItem + 1]);
    setTimeout(() => {
      setSelectValue(`arrangement_group[${lastNumberItem + 1}].arrangement_group.arrangement.value`, "");
    }, 200);
  };

  const deleteItem = (index) => {
    setDeletedProducts([...deletedProducts, index]);
    setTimeout(() => {
      setArrangementsPrice(updateArrangementsPrice());
      if (form.withDiscount) {
        setArrangementsPriceWithoutDiscount(updateArrangementsPriceWithoutDiscount());
        setArrangementsDiscount(updateArrangementsDiscount());
      }
    }, 200);
  };

  const getIndexToShow = (product) => {
    if (includes(product, deletedProducts)) {
      return null;
    }
    const filteredProducts = filter((n) => !includes(n, deletedProducts), numberItems);
    return indexOf(product, filteredProducts);
  };

  return (
    <div style={{ display: display ? "block" : "none" }} className="form__form-wrapper">
      {numberItems.map((t, i) => (
        <Garment
          key={`j-${i}`}
          index={t}
          indexToShow={getIndexToShow(t)}
          form={form}
          register={register}
          setSelectValue={setSelectValue}
          defaultValue={defaultValue}
          errors={errors}
          deleteItem={() => deleteItem(t)}
          setArrangementsPrice={setArrangementsPrice}
          setArrangementsPriceWithoutDiscount={setArrangementsPriceWithoutDiscount}
          setArrangementsDiscount={setArrangementsDiscount}
          setOnFocus={setOnFocus}
          windowSize={windowSize}
          isMobileBrowser={isMobileBrowser}
        />
      ))}
      <div className="transport_add_info only_add" onClick={() => addItem()}>
        {translate("product.add")}
      </div>
    </div>
  );
};

export default GarmentManager;
